/**
 * Created byJose Luis on 2017-08-14.
 * "Customer" service
 *
 * This consumes Customer REST Api
 *
 *
 */
import { serializeParams } from '../common/helpers';
import request from './request';

export const get = (url = '', params = {}) => {
    return request().get(`${url}${serializeParams(params)}`)
        .then(response => {
            return response.data;
        })
        .catch(error => {
            //TODO Hay que hacer un buen manejo de errores. Por ahora simplemente regresamos test data pero se debe borrar y en caso de error en el webservice propagarlo a la vista de alguna forma para que se maneje posteriormente.
            return testData;
            //return error;
        });
};

export const post = (url = '', params = {}) => {
    return request().post(url, params)
        .then(response => {
            return response.data;
        })
        .catch(error => {
            return error;
            console.log("eee");
        });
};

export const put = (url = '', params = {}) => {
    return request().put(url, params)
        .then(response => {
            return response.data;
        })
        .catch(error => {
            return error;
        });
};

/**
 * Url's should stay here... if something change on the API here is the only place to
 * change things.
 */
export const getCustomTabularPrices = (params = {}) => {
    return request()
        .get(`customerTabularPriceses/search/findByCustomerIdAndCustomsHouse${serializeParams(params)}`)
        .then(response => response.data._embedded.customerTabularPriceses)
        .catch(() => []);
};

export const getExpensesTabularPrices = (params = {}) => {
    return request()
        .get(`expensesTabularPriceses/search/findByCustomerTabular${serializeParams(params)}`)
        .then(response => response.data._embedded.expensesTabularPriceses)
        .catch(() => []);
};



// WEBPACK FOOTER //
// ./services/customerTabularPriceses.js